// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"WhyChoose_TheComp__Yp4_j"};